import { render, staticRenderFns } from "./Assemblies.vue?vue&type=template&id=a017bb5c&"
import script from "./Assemblies.vue?vue&type=script&lang=js&"
export * from "./Assemblies.vue?vue&type=script&lang=js&"
import style0 from "./Assemblies.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports